import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import InnerBox from '@repo/ui/inner-box'
import LinkFile from '@repo/ui/link-file'
import Typography from '@repo/ui/typography'

import { FileType } from '../../../lib/types/models/file/file'

type Props = {
  files: FileType[]
  isBadge?: boolean
}

const CenterEventFilesLinkDisplay = ({ files, isBadge }: Props) => {
  return (
    <InnerBox>
      <div className="flex items-center gap-1">
        <Typography variant="text" color={tailwindColors.grey.DEFAULT}>
          Pièces jointes :
        </Typography>
        {files.length === 0 ? (
          <Typography variant="label-medium" color={tailwindColors.primary.DEFAULT}>
            Aucune pièce jointe
          </Typography>
        ) : (
          files.map((file) =>
            isBadge ? (
              <Badge
                key={file.id}
                borderColor={tailwindColors.grey.light.DEFAULT}
                color={tailwindColors.white.hover}
                className="rounded"
                text={<LinkFile file={file} />}
              />
            ) : (
              <LinkFile key={file.id} file={file} />
            )
          )
        )}
      </div>
    </InnerBox>
  )
}

export default CenterEventFilesLinkDisplay
